import {useState} from 'react'

// Atom components
import {Modal} from '@/components/atoms'

// Molecule components
import {UploadFile} from '@/components/molecules'

// Utils
import {uploadFileDescriptionForCSV} from '@/utils/commonTemplate'

// Constants
import {Constants} from '@/utils/constants/commonConstants'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'

/**
 * Modal component for uploading template files with integrated file upload functionality.
 *
 * @param {Object} props - The component props.
 * @param {boolean} props.openUpload - Controls the visibility of the upload modal.
 * @param {Function} props.setOpenUpload - Callback to update the modal's visibility state.
 * @returns {JSX.Element} The rendered upload template modal component.
 */
function UploadTemplateWithModal({openUpload, setOpenUpload, ...props}) {
  const [uploadError, setUploadError] = useState(false)
  const [uploading, setUploading] = useState(false)

  const [formData, setFormData] = useState({
    targetMediaFile: [],
  })

  const handlePrimaryButtonClick = () => {
    setOpenUpload(false)
  }

  const handleDelete = () => {
    setFormData(prev => ({...prev, ...{targetMediaFile: []}}))
  }

  return (
    <Modal
      isDark={true}
      onCloseModal={() => {
        handleDelete()
        setOpenUpload(false)
        setUploadError(false)
      }}
      onClickSecondaryButton={() => {
        handleDelete()
        setOpenUpload(false)
        setUploadError(false)
      }}
      onClickPrimaryButton={handlePrimaryButtonClick}
      showModal={openUpload}
      className="upload-target-modal"
      title={'Upload Product Template'}
      primaryButtonText={'Done'}
      primaryButtonDisabled={formData?.targetMediaFile?.length <= 0 ? true : false}
      type={MODAL_TYPE.SMALL}
      showSecondaryButton={true}
      data-testId="upload-product-template"
      content={
        <UploadFile
          acceptedExtensions={Constants.CSV}
          description={uploadFileDescriptionForCSV()}
          label={Constants.UploadStoresFile}
          variant={Constants.Edit}
          feedbackType={uploadError ? Constants.Error : Constants.Info}
          required={true}
          files={formData?.targetMediaFile?.length > 0 ? [formData?.targetMediaFile] : []}
          onUpload={file => {
            setFormData(prev => ({...prev, ...{targetMediaFile: [file?.name]}}))
            setUploadError(false)
          }}
          onUploadDelete={handleDelete}
          helperText={uploadError ? 'Please use only .CSV file type' : ''}
          onUploadError={error => {
            if (error) {
              setUploadError(true)
            }
          }}
          type={Constants.Single}
          showDownloadTemplate={false}
          showHandleViewTable={false}
          className={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          containerClassName={formData?.targetMediaFile?.length > 0 ? 'disabled' : ''}
          uploading={uploading}
          setUploading={setUploading}
          // dataTestId="upload-file"
          {...props}
        />
      }
    />
  )
}

export default UploadTemplateWithModal
